// Punta Tech — design tokens shared across every section.
// Single source of truth for color and type; mirrors the accent CSS var in styles.css.

export const ACCENT = "#C9A227";

export const C = {
  bg: "#0a0a0a",
  about: "#0d0d0d",
  card: "#111111",
  border: "rgba(255,255,255,0.07)",
  borderStrong: "rgba(255,255,255,0.14)",
  fg: "#FFFFFF",
  body: "#A0A0A0",
  faint: "#606060",
  fainter: "#404040",
};

export const fonts = {
  serif: `'Cormorant Garamond', 'Playfair Display', 'Times New Roman', serif`,
  mono: `'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace`,
  sans: `'Inter', system-ui, -apple-system, sans-serif`,
};
